import type { DigitalSetup, Outcome, Priority, Variant } from '#lib/steps/state';
import {
  DIGITAL_SETUP_WEIGHTS,
  OUTCOME_WEIGHTS,
  PRIORITY_WEIGHTS,
  type WeightedOption,
} from './weights';

const sumWeights = <T extends string>(
  selected: T[] | undefined,
  weights: Record<T, WeightedOption>,
): number => (selected ?? []).reduce((total, id) => total + weights[id].weight, 0);

/**
 * Compute the recommended solution from the user's wizard answers.
 *
 * Steps 1 & 2 are multi-select: every selected option's weight is added, so
 * stacking same-leaning answers strengthens that lean and contradictory ones
 * cancel out. Score ≥ 0 → Hosted (the default for a neutral/empty set);
 * score < 0 → Embedded.
 */
export const computeRecommendedVariant = (
  outcomes: Outcome[] | undefined,
  digitalSetups: DigitalSetup[] | undefined,
  priority: Priority | undefined,
): Variant => {
  const score =
    sumWeights(outcomes, OUTCOME_WEIGHTS) +
    sumWeights(digitalSetups, DIGITAL_SETUP_WEIGHTS) +
    (priority ? PRIORITY_WEIGHTS[priority].weight : 0);

  return score >= 0 ? 'hosted' : 'embedded';
};
